import { styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";

import util from "utils/utils";

const StyledBanner = styled.div<{
  $image?: string;
  $marginless?: boolean;
  $defaultGradient: string;
}>`
  padding: 1rem 0;

  background-image: ${({ $image, $defaultGradient }) =>
    $image ? `url(${$image})` : $defaultGradient};
  background-size: cover;
  background-position: center center;
  margin-bottom: ${({ theme, $marginless }) => {
    if ($marginless) {
      return 0;
    }
    if (theme.sizes.isMobile) {
      return 15;
    }
    return 30;
  }}px;
  position: relative;
  z-index: 10;
  .overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.21);
    z-index: 11;
  }
  .overlay-body {
    position: relative;
    z-index: 12;
  }
  .ui.button.basic {
    background: white !important;
    &:hover {
      background: white !important;
    }
  }
  h1 {
    color: #fff !important;
    font-size: 2.5em;
  }
  p {
    color: #e2e7f3;
    font-size: 1.5em;
  }
  h5,
  h2,
  h3 {
    color: #fff;
  }
`;

const StyledCompactBanner = styled.div<{
  $image?: string;
  $marginless?: boolean;
  $defaultGradient: string;
}>`
  width: 100%;
  background-image: ${({ $image, $defaultGradient }) =>
    $image ? `url(${$image})` : $defaultGradient};
  background-size: cover;
  margin-bottom: 20px;
  background-position: center center;
  box-shadow: 0.5px 0.5px 2.5px 1px #c0c0c0;
  border-radius: 5px;
  padding: 5px;
  position: relative;
  z-index: 10;
  .overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    z-index: 11;
  }
  .overlay-body {
    position: relative;
    z-index: 12;
  }
  .ui.button.basic {
    background: white !important;
    &:hover {
      background: white !important;
    }
  }
  h1 {
    color: #fff !important;
    font-size: 2em;
  }
  p {
    color: #e2e7f3;
    font-size: 1em;
  }
  h5,
  h2,
  h3 {
    color: #fff;
  }
`;

type BannerProps = {
  image?: string;
  style?: React.CSSProperties;
  marginless?: boolean;
  children: React.ReactNode;
  compact?: boolean;
};
const Banner = ({
  image,
  style,
  marginless,
  children,
  compact,
}: BannerProps) => {
  const theme = useTheme();
  const defaultGradient = `linear-gradient(to bottom right, ${theme.secondaryColour}, ${util.adjustColour(theme.secondaryColour, 0.5)})`;
  const BannerComponent = compact ? StyledCompactBanner : StyledBanner;
  return (
    <BannerComponent
      $image={image}
      $marginless={marginless}
      $defaultGradient={defaultGradient}
      style={style}
    >
      {children}
    </BannerComponent>
  );
};

export default Banner;
